<template>
  <div class="print-layout-container">
    <div class="print-top-bar">
      <slot name="top"/>
    </div>
    <div class="print-body-container">
      <slot name="body"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrintLayoutContainer'
}
</script>

<style scoped>
@media screen {
  .print-layout-container {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
  .print-top-bar {
    background: #eee;
    border-bottom: 1px solid #ccc;
    padding-top: 16px;
    padding-bottom: 16px;
    flex: 0 0 auto;
  }
  .print-body-container {
    flex: 1 1 auto;
    padding: 12px;
    background: #f8f8f8;
    overflow-y: auto;
  }
}
@media print {
  .print-layout-container {
    display: block !important;
  }
  .print-top-bar {
    display: none;
  }
}
</style>
